import React from "react";
import Logger from "utils/logger";
import FlatButton from "material-ui/FlatButton";
import { Tabs, Tab } from "material-ui/Tabs";
import { List } from "@terraincognita/ui-core";
// import _cloneDeep from "lodash/cloneDeep";
// import _isEqual from "lodash/isEqual";
import Draggable from "react-draggable";
import SwipeableViews from "react-swipeable-views";
import _map from "lodash/map";
import "./StyleEditModal.scss";

export class StyleEditModal2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabIndex: 0,
      formsLocal: null
    };
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleTabChange(index) {
    this.setState({ tabIndex: index });
  }

  componentDidMount() {
    // Messy hack to get rid of the scene auto advance interval setting
    // if the story isn't configured to advance auto automatically.

    // TODO: In the React 16 CMS, figure out a way to make form elements
    // conditional.
    if (
      !this.props.storyProperties.advanceSlideshowMode ||
      this.props.storyProperties.advanceSlideshowMode !== "automatically"
    ) {
      const formsLocal = {
        ...this.props.forms
      };
      if (formsLocal.design) {
        delete formsLocal.design.autoAdvanceInterval;
      }
      this.setState({
        formsLocal: {
          ...formsLocal
        }
      });
    } else {
      // TODO: Figure out a way to take advantage of the input placeholder
      // prop in the React 16 CMS so we can display the story auto advance
      // interval as a default value.
      this.setState({
        formsLocal: {
          ...this.props.forms
        }
      });
    }
  }

  render() {
    const {
      title,
      tabs,
      forms,
      formData,
      onInputChange,
      onCancel,
      onSave,
      storyProperties
    } = this.props;

    const tabStyle = {
      buttonStyle: {
        backgroundColor: "#d7d7d7",
        color: "rgb(72, 72, 72)"
      }
    };

    const tabsStyle = {};

    return (
      <div className="style-modal-container open">
        <Draggable handle=".handler">
          <div
            className="style-editor-modal"
            style={{
              left: "40%",
              top: "15%"
            }}
          >
            <div className="modal-relative-container">
              <div className="header-container handler">
                <h2>{title}</h2>
              </div>
              <div className="form-container">
                {tabs.length > 1 && (
                  <Tabs
                    {...tabsStyle}
                    onChange={this.handleTabChange}
                    value={this.state.tabIndex}
                  >
                    {tabs &&
                      _map(tabs, (tab, index) => {
                        return (
                          <Tab
                            key={`tab-${tab.label}`}
                            {...tabStyle}
                            label={tab.label}
                            value={index}
                          />
                        );
                      })}
                  </Tabs>
                )}

                <SwipeableViews
                  index={this.state.tabIndex}
                  onChangeIndex={this.handleTabChange}
                >
                  {tabs &&
                    _map(tabs, tab => {
                      Logger.debug(
                        { tab },
                        "[STYLE EDIT MODAL] - swipeable view"
                      );
                      return (
                        <div key={`panel-${tab.label}`}>
                          <List
                            styleName="plain"
                            // items={forms[tab.id]}
                            items={
                              this.state.formsLocal
                                ? this.state.formsLocal[tab.id]
                                : null
                            }
                            data={formData}
                            handleInputChange={onInputChange}
                          />
                        </div>
                      );
                    })}
                </SwipeableViews>
              </div>

              <div className="modal-actions-container">
                <FlatButton onClick={onCancel} label="Cancel" default />
                <FlatButton onClick={onSave} label="Save" primary />
              </div>
            </div>
          </div>
        </Draggable>
        <div className="modal-overlay" onClick={onCancel} />
      </div>
    );
  }
}

export default StyleEditModal2;
